import { inject } from '@angular/core'
import { OidcService } from '@core/authentication/oidc/oidc.service'
import { ProfileStore } from '@core/store/profile/profile.store'
import { OidcStore } from '@core/store/oidc/oidc.store'
import { StartupStore } from '@core/store/startup/startup.store'
import { RouterStore } from '@core/router/router.store'
import { environment } from '@env'

const log = (canLog: boolean, message: string, color = '#ff0097') => {
  if (canLog) {
    console.log(`%c${message}`, `color: ${color}`)
  }
}

export const idsInitializer = () => {
  const _oidc = inject(OidcService)
  const _oidcStore = inject(OidcStore)
  const _profileStore = inject(ProfileStore)
  const _startupStore = inject(StartupStore)
  const _routerStore = inject(RouterStore)
  const canLog = _oidc.debug
  _oidc.manager.events.addUserSignedOut(() => {
    log(canLog, '[OIDC] Event: addUserSignedOut >> Calls: OidcStore.logOut()')
    _oidcStore.logOut()
  })
  _oidc.manager.events.addUserLoaded((oidc) => {
    log(canLog, '[OIDC] Event: addUserLoaded >> Calls: StartupStore.startup({oidc})')
    _startupStore.startup(oidc)
  })
  _oidc.manager.events.addUserUnloaded(() => {
    log(canLog, '[OIDC] Event: addUserUnloaded >> Calls: ProfileStore.purgeUserProfile()')
    _profileStore.purgeUserProfile()
  })
  _oidc.manager.events.addAccessTokenExpiring(() => {
    log(canLog, '[OIDC] Event: addAccessTokenExpiring >> Calls: OidcStore.signInRedirect()')
    _oidcStore.signInRedirect(undefined)
  })
  _oidc.manager.events.addSilentRenewError(() => {
    log(canLog, '[OIDC] Event: addSilentRenewError >> Calls: OidcStore.signInRedirect()')
    _oidcStore.signInRedirect(undefined)
  })

  _oidc.manager.events.removeUserLoaded(() => {
    log(canLog, '[OIDC] Event: removeUserLoaded >> Dispatches: NOTHING')
  })

  _oidc.manager.events.removeUserUnloaded(() => {
    log(canLog, '[OIDC] Event: removeUserUnloaded >> Dispatches: NOTHING')
  })

  _oidc.manager.events.removeSilentRenewError(() => {
    log(canLog, '[OIDC] Event: removeSilentRenewError >> Dispatches: NOTHING')
  })

  _oidc.manager.events.removeUserSignedIn(() => {
    log(canLog, '[OIDC] Event: removeUserSignedIn >> Dispatches: NOTHING')
  })

  _oidc.manager.events.addUserSignedIn(() => {
    log(canLog, '[OIDC] Event: addUserSignedIn >> Dispatches: NOTHING')
  })

  _oidc.manager.events.addUserSessionChanged(() => {
    log(canLog, '[OIDC] Event: addUserSessionChanged >> Dispatches: NOTHING')
  })
  _oidc.manager.events.addSilentRenewError(() => {
    log(
      canLog,
      '[OIDC] Event: addSilentRenewError >> Calls: RouterStore.navigateExternal({path: environment.IDENTITY_SERVER.POST_LOGOUT_REDIRECT_URI})',
    )
    _routerStore.navigateExternal(environment.IDENTITY_SERVER.POST_LOGOUT_REDIRECT_URI)
  })
}
